const headerBt = {
	brand: 'གྲམ་གྱི་ཚོང་ཁང་',
	top: {
		bazarList: 'དཀྱིལ་འཛིན་ཚོང་ཁང་',
		help: 'རོགས་རམ་',
		contact: 'འབུལ་བསྐུར་'
	},
	nav: {
		dailyBazar: 'དུས་ཐོག་རྒྱུ་ཆས་',
		medicineBazar: 'འོས་སྨན་',
		foodBazar: 'བཟས་ཆས་',
		grains: 'སོ་འབྲུ་',
		nationalBazar: 'རྒྱལ་ཡོངས་',
		garmentsBazar: 'གོས་ཆས་',
		cosmeticsBazar: 'རྩིས་བཟོ་ཆས་',
		bookBazar: 'དཔེ་མཛོད་',
		nurseryBazar: 'ཤིང་སྐྱེད་ཁང་',
		electronicsBazar: 'འཕྲུལ་ཆས་',
		chemicalBazar: 'སྤྱིར་བཏང་རྫས་',
		hardwareBazar: 'སྣོལ་ཆས་',
		serviceBazar: 'སྒེར་ཞབས་ཞུ་',
		feedBazar: 'དུད་འབུམ་ཟས་'
	},
	search: {
		placeholder: 'ཁྱེད་ཀྱིས་གང་བཙོང་ན་འདོད།'
	},
	drawer: {
		home: 'ཁྱིམ་',
		dailyBazar: 'དུས་ཐོག་ཚོང་ཁང་',
		medicineBazar: 'འོས་སྨན་ཚོང་ཁང་',
		grains: 'སོ་འབྲུ་ཚོང་ཁང་',
		nationalBazar: 'རྒྱལ་ཡོངས་ཚོང་ཁང་',
		foodBazar: 'བཟས་ཆས་',
		bookBazar: 'དཔེ་མཛོད་ཚོང་ཁང་',
		nurseryBazar: 'ཤིང་སྐྱེད་ཚོང་ཁང་',
		garmentsBazar: 'གོས་ཆས་ཚོང་ཁང་',
		electronicsBazar: 'འཕྲུལ་ཆས་ཚོང་ཁང་',
		chemicalBazar: 'སྤྱིར་བཏང་རྫས་ཚོང་ཁང་',
		hardwareBazar: 'སྣོལ་ཆས་ཚོང་ཁང་',
		cosmeticsBazar: 'རྩིས་བཟོ་ཆས་ཚོང་ཁང་',
		serviceBazar: 'སྒེར་ཞབས་ཞུ་ཚོང་ཁང་',
		feedBazar: 'དུད་འབུམ་ཟས་ཚོང་ཁང་'
	},
	profileMenu: {
		login: 'ཐོ་འགོད་',
		register: 'ཐོ་བཀོད་',
		myAccount: 'ངའི་རྩིས་ཐོ་',
		storeDashboard: 'སོར་ཚོང་ལྟ་སྟོན་',
		adminDashboard: 'དོ་དམ་པའི་ལྟ་སྟོན་'
	}
};

export default headerBt;


